module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-6 w-full"
  }, [_c('div', {
    staticClass: "flex w-full justify-between items-center"
  }, [(!_vm.comment.is_model_submission) ? _c('CommentUserAvatar', {
    attrs: {
      "userName": _vm.standard_name,
      "userProp": _vm.user,
      "timeAgo": _vm.comment.time_ago,
      "dateTimeAgo": _vm.comment.date_time_ago,
      "isCommentCreatedAfterRoundTableEnd": _vm.created_after_end,
      "isCommentMine": _vm.getMyRTUserDetails.id === _vm.comment.user_id &&
        !_vm.hasTeacherPermissionsInCourse
    }
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-star text-amber-300 text-lg mr-2.5 ml-1.5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm font-bold"
  }, [_vm._v("Model Submission")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [(
    _vm.comment.flagged_by.length &&
    _vm.hasTeacherPermissionsInCourse &&
    !_vm.comment.is_model_submission
  ) ? _c('Tooltip', {
    attrs: {
      "text": _vm.flag_tooltip_message,
      "styleTooltip": "top-0 right-full mt-0.5 mr-2 py-1.5",
      "backgroundColor": "bg-coolGray-800",
      "textColor": "text-xs text-gray-100"
    }
  }, [_c('div', {
    staticClass: "mr-2"
  }, [_c('button', {
    staticClass: "w-8 h-8 hover:bg-coolGray-200 rounded-full"
  }, [_c('i', {
    staticClass: "fa fa-flag text-red-600",
    staticStyle: {
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.comment.flagged_by.length))])])]) : _vm._e(), _vm._v(" "), (_vm.userFlaggedComment) ? _c('button', {
    staticClass: "w-8 h-8 hover:bg-coolGray-200 rounded-full mr-2"
  }, [_c('i', {
    staticClass: "fa fa-flag text-red-600",
    staticStyle: {
      "font-size": "12px"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.comment.is_model_submission) ? _c('StarButton', {
    staticClass: "mr-2",
    attrs: {
      "type": "comment-card",
      "comment": _vm.comment
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReportPage && _vm.getMyRTUserDetails.id !== _vm.user.id) ? _c('EntryOptions', {
    staticClass: "-mt-0.5",
    attrs: {
      "entry": _vm.comment,
      "type": 'comment'
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.comment.content) ? _c('div', {
    staticClass: "relative my-3 pl-10 w-full break-words",
    attrs: {
      "id": 'comment-card-' + _vm.comment.id
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFullComments(_vm.comment.id)),
      expression: "showFullComments(comment.id)"
    }],
    staticClass: "relative my-1.5 w-full break-words"
  }, [_c('div', {
    directives: [{
      name: "linkified",
      rawName: "v-linkified:options",
      value: ({
        className: 'underline'
      }),
      expression: "{ className: 'underline' }",
      arg: "options"
    }],
    staticClass: "whitespace-pre-wrap relative",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    },
    on: {
      "click": _vm.goToExternalLink
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showFullComments(_vm.comment.id)),
      expression: "!showFullComments(comment.id)"
    }],
    staticClass: "relative my-1.5 w-full break-words"
  }, [_c('div', {
    directives: [{
      name: "linkified",
      rawName: "v-linkified:options",
      value: ({
        className: 'underline'
      }),
      expression: "{ className: 'underline' }",
      arg: "options"
    }],
    staticClass: "whitespace-pre-wrap relative",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    },
    on: {
      "click": _vm.goToExternalLink
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.comment.content.length > 180),
      expression: "comment.content.length > 180"
    }],
    staticClass: "z-1"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ca214aaa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/commentCard/commentCard.vue
// module id = 1096
// module chunks = 61